var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.info.type,attrs:{"module-item":""}},[_c('h5',[_vm._v("Credits")]),(_vm.info.value.text)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.value.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }